import type { BalancesRepositoryT } from "../../domain/ports/balances.repostory";
import type { BalancesApiT, BalancesMapperT } from "../types/balances.types";

import { extractErrorMessage } from "utils/extractErrorMessage";

type BalancesRepositoryParamsT = {
  balancesApi: BalancesApiT;
  balancesMapper: BalancesMapperT;
};

export const createBalancesRepository = ({
  balancesApi,
  balancesMapper,
}: BalancesRepositoryParamsT): BalancesRepositoryT => ({
  getAll: async ({ typeId, colaboraInstanceId, page, pageSize }) => {
    try {
      const response = await balancesApi.getAll({
        typeId,
        colaboraInstanceId,
        page,
        pageSize,
      });

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al obtener los saldos de vacaciones");
      }

      return balancesMapper.balancesDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los saldos de vacaciones",
      );

      throw new Error(message);
    }
  },
});
